// extracted by mini-css-extract-plugin
export default {"ContainerPrincipal":"estilo_ContainerPrincipal__slUaU","titulo":"estilo_titulo__wdf-U"};